import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { observer, inject } from 'mobx-react';
import PrepargingImage from '../../static/images/preparing.png';
import Progress from '../common/Progress';
import { Button } from '@mui/material';

@inject('menuStore', 'commonStore')
@observer
class Preparing extends Component {
  async componentDidMount() {
    const { commonStore, match } = this.props;
    commonStore.setData(match.params.companyId.toLowerCase(), match.params.storeCode);
  }

  handleClickHome = () => {
    const { location, match } = this.props;
    window.location.href = `/${match.params.companyId.toLowerCase()}/${match.params.storeCode}${location.search}`;
  };

  render() {
    const { menuStore, t } = this.props;
    const week = [
      t('common.label.sunday'),
      t('common.label.monday'),
      t('common.label.tuesday'),
      t('common.label.wednesday'),
      t('common.label.thursday'),
      t('common.label.friday'),
      t('common.label.saturday'),
    ];
    if (!menuStore.storeData) return <Progress />;
    return (
      <div className="error-container">
        <div className="error-top"></div>
        <div className="error-content">
          <div>
            <img src={PrepargingImage} alt="준비중" width="260" />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <p>{t('shop.label.businessHours')}</p>
            <ul
              style={{
                margin: 0,
                padding: 0,
                listStyle: 'none',
                textAlign: 'left',
              }}
            >
              {menuStore.storeData.businessTimes.map((businessTime, i) => {
                if (businessTime.endTime === '0000') businessTime.endTime = '2400';

                const sHour = businessTime.startTime.substr(0, 2);
                const sMinute = businessTime.startTime.substr(2, 2);
                const eHour = businessTime.endTime.substr(0, 2);
                const eMinute = businessTime.endTime.substr(2, 2);
                return (
                  <li key={i}>
                    <span className={`week${i}`}>{week[i]}</span> {`${sHour}:${sMinute} ~ ${eHour}:${eMinute}`}{' '}
                    {businessTime.isClosed === '1' && (
                      <span>
                        (<font color="red">{t('shop.label.dayOff')}</font>)
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="error-button">
            <Button component="a" variant="contained" color="secondary" onClick={this.handleClickHome}>
              HOME
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withTranslation()(Preparing));
